import { Component, OnInit, Input } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';
import { Constants } from 'src/app/config/constants';

@Component({
  selector: 'app-schedule-auto-assign',
  templateUrl: './schedule-auto-assign.component.html',
  styleUrls: ['./schedule-auto-assign.component.scss'],
  standalone: false
})
export class ScheduleAutoAssignComponent implements OnInit {
  @Input() orderItem: any;
  @Input() isReDispatch: any;
  schedulingOptions: any = Constants.schedulingOptions;
  selectedIndex: any;
  selectedIndexSubOptIndex: any;
  selectedSchedule: any;

  constructor(
    private modalCtrl: ModalController,
    public commonService: CommonService,
  ) { }

  ngOnInit() { }

  selectSchedule(type: any, i: any) {
    this.selectedIndex = i;
    if (type == 'NOW' || type == 'TOMORROW') {
      this.selectedSchedule = type;
      this.scheduleAutoAssign();
    }
  }

  selectSubSchedule(type: any, i: any) {
    this.selectedIndexSubOptIndex = i;
    this.selectedSchedule = type;
    this.scheduleAutoAssign();
  }

  scheduleAutoAssign() {
    this.modalCtrl.dismiss({ scheduledTimeForAutoAssign: this.selectedSchedule });
  }

  async action() {
    return await this.modalCtrl.dismiss();
  }
}
